import * as React from 'react';
import { APIError } from '../APIError';
import { HTTP_STATUS, mergeClasses } from '../constants';
import Icon from './Icons';

type Props = {
  className?: string;
  error: APIError;
  size?: string;
  message?: React.ReactNode;
};

export default class ErrorJumbotron extends React.Component<Props> {
  render() {
    const { className, error, size, message } = this.props;
    let ErrorIcon;
    switch (error.status) {
      case HTTP_STATUS.SERVER_UNAVAILABLE:
        ErrorIcon = Icon.Clock;
        break;
      case HTTP_STATUS.GATEWAY_TIMEOUT:
        ErrorIcon = Icon.Clock;
        break;
      case HTTP_STATUS.BAD_REQUEST:
        ErrorIcon = Icon.Prohibited;
        break;
      case HTTP_STATUS.NOT_FOUND:
        ErrorIcon = Icon.Search;
        break;
      case 0:
        ErrorIcon = Icon.Plug;
        break;
      default:
        ErrorIcon = Icon.Exclamation;
    }
    return (
      <div
        className={mergeClasses([
          'jumbotron-sizing',
          'gray-box',
          className,
          size,
        ])}
      >
        <ErrorIcon size={36} className="mr-3" />
        {message || error.message}
      </div>
    );
  }
}
